/** QUICKSHOP JS */

// PDP CAROUSEL WITH THUMBS on QuickShop
var initSlider = function() { 
  $('.quickshop-content .js-slider-primary').slick('unslick');
  $('.quickshop-content .js-slider-nav').slick('unslick');

  $('.quickshop-content .js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.quickshop-content .js-slider-nav'
  });

  $('.quickshop-content .js-slider-nav').slick({
    slidesToScroll: 1,
    asNavFor: '.quickshop-content .js-slider-primary',
    dots: false,
    focusOnSelect: true,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    vertical: true,
    prevArrow: "<a href='#' class='previous-arrow'><i class='fal fa-chevron-up'></i></a>",
    nextArrow: "<a href='#' class='next-arrow'><i class='fal fa-chevron-down'></i></a>",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          prevArrow: "<a href='#' class='previous-arrow'><i class='fal fa-chevron-left'></i></a>",
          nextArrow: "<a href='#' class='next-arrow'><i class='fal fa-chevron-right'></i></a>",
        }
      }
    ]
  });
}

$('body')
.on('click', '[data-quickshop]', function() {
  var product_handle = $(this).data('quickshop');

  $.ajax({
    url: `/products/${product_handle}?view=ajax`,
    dataType: "html"
  })
  .done(function(response) { 
    var $container = $('#hidden-content #quickShop');
    $container.empty();
    $container.html(response);

    initSlider();

    if ( window.SPR ) { 
      SPR.initDomEls();
      SPR.loadProducts();
      SPR.loadBadges();
    }

    $.fancybox.open({
      src  : '#hidden-content',
      opts : {
        afterShow : function( instance, current ) {
          console.info( 'done!' );
        }
      }
    });
  })
})


/* JS Quantity Incrementers */
.on('click', '.component-quickshop .js-qty-wrap span', function() { 
  var $this    = $(this),
      $parent  = $(this).closest('.js-qty-wrap')
      $inputEl = $parent.find('input'),
      qtyValue = parseInt($inputEl.val());

  if ( $this.hasClass('plus') ) { 
    qtyValue += 1;
  } else { 
    qtyValue -= 1;
    if ( qtyValue < 1 ) { 
      qtyValue = 1;
    }
  }

  $inputEl.val(qtyValue);
})
